"use strict";
(function overflowMenuAdmin(win) {
    // @ts-ignore
    var PPVX = win.PPVX;
    var root = PPVX.getRoot(); // Method to get all the details required for handling keyboard and click events
    var overflowMenu = function overflowMenu(event) {
        var target = event.target;
        var overflowMenuId = target.getAttribute("data-overflow-menu");
        var currentOverflowMenu = PPVX.getValue("currentOverflow.currentOverflowObj");
        var currentOverflowMenuId = PPVX.getValue("currentOverflow.currentOverflowId");
        /*
          Boolean flag - based on this we set the focus state of the button
          Used for accessibility
        */
        var isSameOverflowMenu = overflowMenuId === currentOverflowMenuId
            ? true
            : event.target.classList.contains("ppvx_overflow-menu__list-item");
        return {
            target: target,
            overflowMenuId: overflowMenuId,
            currentOverflowMenu: currentOverflowMenu,
            currentOverflowMenuId: currentOverflowMenuId,
            isSameOverflowMenu: isSameOverflowMenu,
        };
    }; // Method to handle the keyboard events - Escape and Tab
    var handleKeyboard = function handleKeyboard(event) {
        var obj = overflowMenu(event);
        var ESC = 27;
        var TAB = 9;
        var keyCode = event.key || event.keyCode;
        switch (keyCode) {
            case "Escape":
            case ESC:
                /* eslint-disable no-use-before-define */
                handleClose(obj.currentOverflowMenu, obj.isSameOverflowMenu);
                /* eslint-enable no-use-before-define */
                break;
            case "Tab":
            case TAB:
                /* eslint-disable no-use-before-define */
                handleClose(obj.currentOverflowMenu, obj.isSameOverflowMenu);
                /* eslint-enable no-use-before-define */
                break;
            default:
                break;
        }
    }; // Method to close the Menu
    var handleClose = function handleClose(currentOverflowMenu, isSameOverflowMenu) {
        currentOverflowMenu.close(isSameOverflowMenu);
        PPVX.setValue("currentOverflow", {}); // eslint-disable no-use-before-define
        root.removeEventListener("keydown", handleKeyboard, false); // eslint-enable no-use-before-define
    }; // Method to open the menu
    var handleOpen = function handleOpen(target, overflowMenuId) {
        var overflowMenuObj = new PPVX.OverflowMenu(target);
        overflowMenuObj.open();
        PPVX.setValue("currentOverflow", {
            currentOverflowObj: overflowMenuObj,
            currentOverflowId: overflowMenuId,
        });
        root.addEventListener("keydown", handleKeyboard, false);
    };
    /*
      Method to handle events on overflow menu
      is the element clicked is a overflow menu
        if yes, check if the menu is open
          if yes, is it the same menu clicked
            close the menu
          if no, close the other menu and open the clicked menu
        if no, open the menu
      if no, check if there is any menu open and close it
    */
    var handleOverflowMenu = function handleOverflowMenu(event) {
        // Check if matching id exists:
        var target = event.target;
        var id = target.getAttribute("data-overflow-menu");
        if (id && id.startsWith("editRemoveMenu")) {
            event.preventDefault();
        }
        var idMatch = document.getElementById(id);
        var obj = overflowMenu(event);
        if (obj.currentOverflowMenu && obj.currentOverflowMenu.isOpen()) {
            handleClose(obj.currentOverflowMenu, obj.isSameOverflowMenu);
        }
        if (idMatch && !obj.isSameOverflowMenu) {
            handleOpen(obj.target, obj.overflowMenuId);
        }
    };
    root.addEventListener("click", handleOverflowMenu, false);
})(window);
